<template>
  <main class="main-page" style="height: 100%">
    <v-container fluid style="height: 100%">
      <v-row
        align="center"
        justify="center"
        style="height: 100%"
        v-if="isLoading"
      >
        <RingLoader color="#7ed321" />
      </v-row>
      <!-- <span style="color: #FF5733; font-size: 14px"><b>**** ปิดปรับปรุงระบบ ช่วงเวลา 14:00 - 16:00 นะคะ</b></span> -->
      <v-form @submit="submit" ref="form" v-model="valid">
        <div id="deposit" v-if="!isLoading">
          <Avatar :img="img" :displayName="displayName"></Avatar>
          <v-row class="pl-2 pr-2">
            <v-col cols="12">
              <v-row>
                <v-col cols="6">
                  <span>{{ level == "" ? "Rookie" : level }}</span
                  ><br />
                  <span style="font-size: 12px">{{ totalDeposit }}</span>
                </v-col>
                <v-col cols="6" align="end" v-if="nextScore != 0">
                  <span> {{ nextLevel }} </span><br />
                  <span style="font-size: 12px">{{ nextScore }}</span>
                </v-col>
              </v-row>
              <v-progress-linear
                height="15"
                :value="nextScore == 0 ? 100 : (totalDeposit / nextScore) * 100"
              ></v-progress-linear>
              <v-row class="pt-2">
                <v-col cols="6">
                  <!-- <v-btn color="grey">?</v-btn> -->
                  <img :src="getImg(level)" style="width: 50%" />
                </v-col>
                <v-col cols="6" align="end">
                  <img
                    v-if="nextScore != 0"
                    :src="getImg(nextLevel)"
                    style="width: 50%"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="pl-2 pr-2" align="center" justify="center">
            <v-col cols="12">
              <h2 style="color: #7ed321">ฝากเงินเข้าสู่ระบบ</h2>
              <span style="color: #ababab; font-size: 14px"
                >กรุณาฝากเงินด้วยบัญชีธนาคารที่แสดงไว้เท่านั้น
                มิฉะนั้นระบบจะไม่สามารถเติมเงินให้ท่านได้</span
              >
               <br/>
              <!-- <span style="color: #FF5733; font-size: 14px"><b>**** กรุณางดฝากเงินด้วย บัญชี ธ. กสิกรไทย (Kbank) ในขณะนี้</b></span> -->
            </v-col>
            <!-- <v-col cols="12" align="end">
            <v-btn>เพิ่มบัญชี</v-btn>
          </v-col> -->
            <v-col cols="12" class="pa-0">
              <v-data-table
                :headers="headers"
                :items="accounts"
                :items-per-page="5"
                class="elevation-1"
                mobile-breakpoint="0"
                item-key="id"
                v-model="selectedItem"
                :show-select="isShow"
                :single-select="true"
              >
                <template v-slot:[`item.bankName`]="{ item }">
                  <img :src="item.bankName" style="width: 25px; height: 25px" />
                </template>
                <!-- <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.id" :active="selectedItem == item.id" @click="selectedItem = item.id">
                    <td class="d-sm-table-cell">
                      <img
                        :src="item.bank_name"
                        style="width: 25px; height: 25px"
                      />
                    </td>
                    <td class="d-sm-table-cell">
                      {{ item.account_no }}
                    </td>
                    <td class="d-sm-table-cell">
                      {{ item.name }}
                    </td>
                  </tr>
                </tbody>
              </template> -->
              </v-data-table></v-col
            >
          </v-row>
          <v-row class="pr-2 pl-2">
            <v-col cols="12">
              <h4 style="color: #898989">ระบุจำนวนเงิน</h4>
              <v-text-field
                label="0.00"
                type="number"
                prepend-inner-icon=""
                prefix="|"
                required
                solo-inverted
                v-model="amount"
                :error-messages="amountErrors"
                @input="$v.amount.$touch()"
                @blur="$v.amount.$touch()"
                :rules="[rules.amountRule]"
                hide-details
              ></v-text-field>
              <v-row style="margin-bottom: 5px">
                <v-col cols="12" style="color: #7ed321; font-size: 12px"
                  >Specify amount
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="3" class="pt-0">
                  <v-btn
                    rounded
                    style="color: #1976d2"
                    elevation="0"
                    @click="quickAmount(100)"
                    >100</v-btn
                  >
                </v-col>
                <v-col cols="3" class="pt-0">
                  <v-btn
                    rounded
                    style="color: #1976d2"
                    elevation="0"
                    @click="quickAmount(500)"
                    >500</v-btn
                  >
                </v-col>
                <v-col cols="3" class="pt-0">
                  <v-btn
                    rounded
                    style="color: #1976d2"
                    elevation="0"
                    @click="quickAmount(1000)"
                    >1,000</v-btn
                  >
                </v-col>
                <v-col cols="3" class="pt-0">
                  <v-btn
                    rounded
                    style="color: #1976d2"
                    elevation="0"
                    @click="quickAmount(5000)"
                    >5,000</v-btn
                  >
                </v-col>
                <v-col cols="12">
                  <span style="color: #ababab">ขั้นต่ำ 100 บาท</span><br />
                  <span style="color: #ababab">สูงสุด 49,000 บาท</span>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    block
                    elevation="2"
                    x-large
                    @click="submit"
                    :style="
                      amount >= 100 && amount <= 49000
                        ? 'background-color: #7ed321'
                        : ''
                    "
                    :disabled="amount < 100 || amount > 49000"
                    >ฝากเงิน</v-btn>  
                  <div class="pa-3" style="color: #aeaeae; font-size: 14px">
                    <span class="mb-3"
                      >&nbsp;&nbsp;&nbsp;&nbsp; โปรดทราบ!
                      รายการฝากจะถูกปรับยอดเข้าสู่ <b>บัญชีเบ็ดเตล็ด (Common Wallet)</b>
                      โดยอัตโนมัติ หากท่านต้องการใช้ยอดเงินนี้ที่ผลิตภัณฑ์อื่น
                      กรุณาทำรายการย้ายเงินด้วยตนเอง
                      ที่หน้าแคชเชียร์ธนาคารออนไลน์</span
                    >
                    <span
                      >เนื่องจากธนาคารจะมีการปรับปรุงระบบทุกวัน
                      กรุณาหลีกเลี่ยงการทำธุรกรรมการเงินในช่วงเวลา ดังนี้
                    </span>
                    <br />
                    <div style="margin-left: 50px">
                      (SCB) ไทยพาณิชย์ 23.00 - 00.00 น. <br />
                      (KTB) กรุงไทย 23.00 - 03.00 น. <br />
                      (KBank) กสิกรไทย 00.00 - 01.10 น. <br />
                      (BBL) กรุงเทพ 23.00 - 23.30 น. <br />
                      (BAY) กรุงศรี 23.00 - 02.00 น. และ 02.30 - 04.00 น. <br />
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </v-container>
  </main>
</template>

<script>
import Avatar from "../components/Avatar";
import liff from "@line/liff";
import playerService from "../services/player_service";
import { RingLoader } from "vue-spinners-css";
import transactionService from "../services/transaction_service.js";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import ttb from "../assets/TTB.jpeg";

export default {
  components: { Avatar, RingLoader },
  mixins: [validationMixin],
  validations: {
    amount: { required },
  },
  data: () => ({
    valid: true,
    displayName: "",
    img: "",
    lineId: "",
    isLoading: false,
    isSuccess: false,
    errorMsg: "",
    headers: [
      {
        text: "Bank",
        value: "bankName",
        sortable: false,
      },
      { text: "Acc no.", value: "account_no", sortable: false },
      { text: "Name", value: "name", sortable: false },
    ],
    accounts: [],
    amount: "",
    username: "",
    playerId: "",
    bankName: "",
    accountNo: "",
    accountNameEn: "",
    accountSurnameEn: "",
    accountNameTh: "",
    accountSurnameTh: "",
    resultAccountName: "",
    partner: "",
    status: "",
    score: 0,
    selectedItem: [],
    isShow: false,
    totalDeposit: 0,
    level: "",
    nextScore: 0,
    nextLevel: "",
    itemsBankprovider: [
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FSCB.png?alt=media&token=4bcea6cf-b654-47ce-a099-7ec62c95169f",
        name: "ธนาคารไทยพาณิชย์",
        shortname: "SCB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKBNK.png?alt=media&token=9a4c15d8-ef3c-43a4-bc4e-0498b1a7fa1d",
        name: "ธนาคารกสิกรไทย",
        shortname: "KBNK",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKTBA.png?alt=media&token=f48498e0-331e-484e-98a2-99880d10cb06",
        name: "ธนาคารกรุงไทย",
        shortname: "KTB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBBLA.png?alt=media&token=f563a3e0-fcdc-4135-ac8e-878fa44eeaef",
        name: "ธนาคารกรุงเทพ",
        shortname: "BBL",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBAYA.png?alt=media&token=e3c78d16-0c04-47ae-9280-867aaef46feb",
        name: "ธนาคารกรุงศรีอยุธยา",
        shortname: "BAY",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FGSBA.png?alt=media&token=c0d650ae-6748-445d-bc4f-ce8843b9706c",
        name: "ธนาคารออมสิน",
        shortname: "GSBA",
      },
      // {
      //   logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FTMBA.png?alt=media&token=210fdf60-2efe-4043-b982-55bcba748cf0",
      //   name: "ธนาคารทหารไทย",
      //   shortname: "TMBA",
      // },
      // {
      //   logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FTBNK.jpg?alt=media&token=51a47ad4-f37c-4573-b7dd-b2dc53ad4d8a",
      //   name: "ธนาคารธนชาต",
      //   shortname: "TBNK",
      // },
      {
        logo: ttb,
        name: "ธนาคารทีเอ็มบีธนชาต",
        shortname: "TMB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKKBA.png?alt=media&token=ac103755-a94a-40d4-afef-2383dcb73e89",
        name: "ธนาคารเกียรตินาคิน",
        shortname: "KKBA",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FGHBA.png?alt=media&token=4caa517e-2d35-4413-8be9-ddfb09ff88b7",
        name: "ธนาคารอาคารสงเคราะห์",
        shortname: "GHBA",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBAAC.png?alt=media&token=db135e19-2125-43bb-a4aa-a70b0977f744",
        name: "ธนาคารเพื่อการเกษตรและสหกรณ์",
        shortname: "BAAC",
      },
    ],
    rules: {
      amountRule: (value) => {
        const pattern = /^\d+$/;
        if (!pattern.test(value)) {
          return "กรุณากรอกจำนวนเงินให้ถูกต้อง";
        }
        if (value < 100) {
          return "กรุณาฝากเงิน ตั้งแต่ 100 บาทขึ้นไป";
        }
        if (value > 49000) {
          return "กรุณาฝากเงินไม่เกิน 49,000 บาท";
        }
      },
    },
  }),
  computed: {
    amountErrors() {
      const errors = [];
      if (!this.$v.amount.$dirty) return errors;
      !this.$v.amount.required && errors.push("กรุณาใส่ยอดเงิน");
      return errors;
    },
  },
  created() {
    this.getLineLiff();
  },
  methods: {
    getLineLiff() {
      this.isLoading = true;
      liff
        .init({
          liffId: "1657076095-1JvDAoWx", // prod
          // liffId: "1657078715-18BnkoZy", //local
        })
        .then(async () => {
          if (liff.isLoggedIn()) {
            let getProfile = await liff.getProfile();
            this.displayName = getProfile.displayName;
            this.img = getProfile.pictureUrl;
            this.lineId = getProfile.userId;
            this.getPlayerAccount(this.lineId);
            this.getRank(this.lineId);
          } else {
            liff.login();
          }
        })
        .catch((err) => {
          // Error happens during initialization
          console.log(err.code, err.message);
        });
    },
    getPlayerAccount(lineId) {
      this.isLoading = true;
      playerService
        .getPlayer(lineId)
        .then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].status == "active") {
              this.accounts.push({
                id: res.data[i].id,
                bankName: res.data[i].bankName,
                account_no: res.data[i].accountNo,
                name:
                  res.data[i].accountNameEn +
                  " " +
                  res.data[i].accountSurnameEn,
                accountNameEn: res.data[i].accountNameEn,
                accountSurnameEn: res.data[i].accountSurnameEn,
              });
            }
          }
          for (let j = 0; j < this.accounts.length; j++) {
            for (let k = 0; k < this.itemsBankprovider.length; k++) {
              if (
                this.accounts[j].bankName == this.itemsBankprovider[k].shortname
              ) {
                this.accounts[j].bankName = this.itemsBankprovider[k].logo;
              }
            }
          }
          if (this.accounts.length > 1) {
            this.isShow = true;
          } else if (this.accounts.length == 0) {
            this.$toast.error("กรุณาเพิ่มบัญชีหรือรอบัญชีอนุมัติ", {
              position: "top-center",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
            // setTimeout(() => {
            //   location.replace("https://liff.line.me/1657076095-KJwRrNal");
            // }, 5000);
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          // this.errorMsg = error.message;
          this.errored = true;
        });
    },
    getRank(lineId) {
      this.isLoading = true;
      playerService
        .getRank(lineId)
        .then((res) => {
          //console.log(res);
          this.totalDeposit = res.data.totalDeposit;
          this.level = res.data.level;
          this.nextScore = res.data.nextScore;
          this.nextLevel = res.data.nextLevel;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          // this.errorMsg = error.message;
          this.errored = true;
        });
    },
    getImg(img) {
      if (img != null) {
        return require(`../assets/rank/${img}.png`);
      } else {
        return require(`../assets/rank/Rookie.png`);
      }
    },
    quickAmount(amount) {
      this.amount = amount;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        // this.submitStatus = "ERROR";
        return;
      } else {
        this.errorMsg = "";
        this.isLoading = true;
        let body = {};
        if (this.isShow) {
          if (this.selectedItem == null) {
            this.errorMsg = "กรุณาเลือกบัญชี";
            return;
          } else {
            this.errorMsg = "";
            body = {
              amount: Number(this.amount),
              username: "",
              accountNameEn: this.selectedItem[0].accountNameEn,
              accountSurnameEn: this.selectedItem[0].accountSurnameEn,
              selectedAccountID: this.selectedItem[0].id,
              lineID: this.lineId,
            };
          }
        } else {
          body = {
            amount: Number(this.amount),
            username: "",
            accountNameEn: this.accounts[0].accountNameEn,
            accountSurnameEn: this.accounts[0].accountSurnameEn,
            selectedAccountID: this.accounts[0].id,
            lineID: this.lineId,
          };
        }
        transactionService
          .postTransaction(body)
          .then((res) => {
            //console.log(res);
            this.isLoading = false;
            this.$toast.success(res.data.message, {
              position: "top-center",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
            setTimeout(() => {
              liff.closeWindow();
            }, 2000);
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(error);
            // this.errorMsg = error.response.data.display_message;
            this.$toast.error(error.response.data.display_message, {
              position: "top-center",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
            this.errored = true;
          });
      }
    },
  },
};
</script>

<style>
</style>
